<template>
	<div class="questionnarie-status">
		<div class="all-status bg-white layout-row layout-wrap">
			<div class="member layout-row layout-hv-center" v-for="(member, i) in editStoryData.questionnaireStatus" :key="i">
				<div class="id layout-row layout-hv-center color-white" :class="bgClass(member.status)">{{i + 1}}</div>
				<div class="name layout-row layout-hv-centerr" :class="colorClass(member.status)">{{member.name}}</div>
				<div class="status layout-row layout-hv-center color-danger" v-if="!member.status">尚未填寫</div>
				<div class="status layout-row layout-hv-center color-green1" v-if="member.status">已填寫</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	data() {
		return {};
	},
	computed: {
		...mapState("story", ["editStoryData"])
	},
	methods: {
		colorClass(status) {
			return {
				"color-green1": status,
				"color-danger": !status
			};
		},
		bgClass(status) {
			return {
				"bg-green1": status,
				"bg-danger": !status
			};
		}
	},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.all-status {
	padding: 15px 13px 0 13px;
	width: 100%;

	.member {
		margin-right: 20px;
		margin-bottom: 15px;

		.id {
			width: 19px;
			height: 19px;
			border-radius: 100px;
			margin-right: 5px;
		}

		.name {
			margin-right: 5px;
		}
	}
}
</style>